import loadView from "@/utils/load-view";

const routes = [
    {
        path: "/skills",
        name: "Skills",
        component: loadView("Skill"),
        meta: {
            authRequired: true,
            requiredPermissions: ["A_SKILL"],
            resolvers: [
                () => ({ type: "skills/getSkills", payload: { showAll: true } }),
                () => ({ type: "skills/getCategories" }),
                () => ({ type: "skills/getMatrix", payload: { matrixMode: "all" } }),
                () => ({ type: "teams/customrole/getList" }),
                () => ({ type: "teams/local/getList", payload: { filter: "all", cache: true } }),
            ],
        },
        children: [
            {
                path: "/skills/create",
                name: "SkillCreate",
                component: loadView("SkillEdit"),
                meta: {
                    authRequired: true,
                    modal: true,
                },
            },
            {
                path: "/skills/edit/:id",
                name: "SkillEdit",
                props: true,
                component: loadView("SkillEdit"),
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        to => ({ type: "skills/getSkillDetails", payload: { id: to.params.id } }),
                    ],
                },
            },
            {
                path: "/skills/remove/:id",
                name: "SkillRemove",
                props: true,
                component: loadView("SkillRemove"),
                meta: {
                    authRequired: true,
                    modal: true,
                },
            },
            {
                path: "/skills/categories/:id",
                name: "SkillsManageCategories",
                component: loadView("SkillManageCategories"),
                props: true,
                meta: {
                    authRequired: true,
                },
            },
            {
                path: "/skills/levels/:id",
                name: "SkillsManageLevels",
                component: loadView("UsersTeamsManageLevels"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => {
                            if (to.params.id !== "list") {
                                return {
                                    type: "teams/customrole/get",
                                    payload: { id: to.params.id },
                                };
                            } else {
                                return {
                                    type: "teams/customrole/getList",
                                };
                            }
                        },
                    ],
                },
            },
            {
                path: "/skills/teams/list",
                name: "SkillsManageTeams",
                component: loadView("UsersTeamsManageTeams"),
                props: route => ({ ...route.params, id: "list" }),
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({
                            type: "teams/local/getList",
                            payload: { filter: "allStacked" },
                        }),
                    ],
                },
            },
            {
                path: "/skills/teams/new",
                name: "SkillsManageTeamsNew",
                component: loadView("UsersTeamsManageTeams"),
                props: route => ({ ...route.params, id: "new" }),
                meta: {
                    authRequired: true,
                },
            },
            {
                path: "/skills/teams/:id",
                name: "SkillsManageTeamsDetails",
                component: loadView("UsersTeamsManageTeams"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => ({
                            type: "teams/local/get",
                            payload: { id: to.params.id },
                        }),
                    ],
                },
            },
        ],
    },
    {
        path: "/skill/matrix/:mode",
        name: "SkillMatrix",
        component: loadView("SkillMatrix"),
        meta: {
            authRequired: true,
            resolvers: [
                to => ({ type: "skills/getMatrix", payload: { matrixMode: to.params.mode } }),
                () => ({ type: "teams/customrole/getList" }),
                () => ({ type: "teams/local/getList", payload: { filter: "all", cache: true } }),
            ],
        },
    },
];

export default routes;
